import type { RadioProps } from './Radio.types'
import * as S from './Radio.styles'
import FormControlLabel from '../FormControlLabel'

const Radio = <T extends string | number>({
  value,
  label,
  disabled,
  color = 'primary',
  disableRipple = true,
  ...props
}: RadioProps<T>) => (
  <FormControlLabel
    value={value}
    label={label}
    disabled={disabled}
    control={<S.Radio color={color} disableRipple={disableRipple} {...props} />}
  />
)

export default Radio
